import { GetterTree } from 'vuex';
import { GlobalState } from '../types';
import { SessionsState, Session } from './types';

export const getters: GetterTree<SessionsState, GlobalState> = {
    currentSessions(state): Session[] | null {
        return (state.sessions || []).filter((s) => {
            return s.valid >= 0;
        });
    },

    recentSessions(state): Session[] | null {
        return (state.recents || []);
    },

    isPulling(state): boolean {
        return state.pulling;
    },
};
